import React from 'react';
import ContentLayout from 'src/components/ContentLayout';
import Text from 'src/components/Text';
import styles from './styles.module.scss';

const PrivacyPolicy: React.FC = () => {
  return (
    <ContentLayout size="medium" className={styles['root']}>
      <Text type="p" className={styles['header-text']}>Редакция от 01.08.2023 г.</Text>
      <Text type="h1" className={styles['h1']}>
        ПОЛИТИКА ЗАКРЫТОГО АКЦИОНЕРНОГО ОБЩЕСТВА «ИНФОРАС» В ОТНОШЕНИИ ОБРАБОТКИ И ЗАЩИТЫ ПЕРСОНАЛЬНЫХ ДАННЫХ
      </Text>
      <Text type="h2">1. Общие положения</Text>
      <ul>
        <li>
          <Text type="p">
            1.1. Настоящая политика (далее – «Политика») разработана в соответствии со ст.18.1 Федерального закона от
            27.07.2006 №152-ФЗ «О персональных данных» (далее – «Закон о ПДн») и является локальным нормативным документом
            Закрытого акционерного общества «ИнфорАС» (далее – «Общество»), определяющим ключевые направления его
            деятельности в области обработки и защиты персональных данных (далее – «ПДн»), оператором которых является
            Общество.
          </Text>
        </li>
        <li>
          <Text type="p">
            1.2. Политика разработана в целях реализации требований законодательства в области обработки и защиты ПДн
            как одна из правовых мер, направленных на обеспечение защиты прав и свобод человека и гражданина при
            обработке его ПДн в Обществе.
          </Text>
        </li>
        <li>
          <Text type="p">
            1.3. Положения Политики распространяются на отношения по обработке и защите ПДн, полученных Обществом как
            до, так и после утверждения Политики, за исключением случаев, когда по причинам правового, организационного
            и иного характера положения Политики не могут быть распространены на отношения по обработке и защите ПДн,
            полученных до ее утверждения.
          </Text>
        </li>
        <li>
          <Text type="p">
            1.4. Настоящая Политика публикуется на сайте Общества www.sbp.1c.ru в целях возможности ознакомления
            с ней неограниченного круга лиц.
          </Text>
        </li>
        <li>
          <Text type="p">
            1.5. Настоящая Политика может в любой момент изменяться Обществом с учетом изменяющихся требований
            законодательства и развития технических и организационных мер защиты ПДн. В случае изменения настоящей
            Политики, Общество размещает ее новую редакцию на сайте Общества, что признается надлежащим уведомлением
            субъекта ПДн.
          </Text>
        </li>
      </ul>
      <Text type="h2">2. Основания и цели обработки персональных данных Обществом</Text>
      <ul>
        <li>
          <Text type="p">
            2.1. Обработка ПДн осуществляется в процессе ведения уставной деятельности Общества, в следующих целях:
            установления и прекращения трудовых отношений с физическими лицами; выполнения договорных обязательств
            перед контрагентами; управления и проведения корпоративных процедур Общества, проверки благонадежности
            контрагентов, учёта доверенных (уполномоченных) лиц контрагентов; организации бухгалтерского и налогового
            учета, подготовка регламентированной отчетности; осуществлении досудебной и судебной работы, в т.ч. в
            целях взыскания дебиторской задолженности; исполнения запросов уполномоченных государственных и
            муниципальных органов, а также субъектов персональных данных; выполнения требований законодательных актов,
            нормативных документов и иных нормативно-правовых актов, в части передачи информации третьим лицам;
            проведения рекламных и маркетинговых акций, в том числе рекламных и маркетинговых акций третьих лиц;
            идентификации посетителя сайта; регистрации (авторизации) посетителей на сайте и в сервисах с целью
            получения продуктов; установления обратной связи, включая направление уведомлений, запросов, касающихся,
            оказания услуг, обработки запросов и заявок от посетителя сайта (пользователя сервисов); предотвращения
            мошенничества или иных противоправных действий, в том числе предотвращения злоупотреблений и нарушений
            прав пользователей сервисов и прав других лиц; предоставления доступа посетителям на сайты или к сервисам
            с целью получения продуктов, обновлений и услуг, в том числе услуг поддержки; подбора кадров; содействия
            соискателям в трудоустройстве; обучения и продвижение по службе; контроля количества и качества выполняемой
            работы, оказываемых услуг; обеспечения личной безопасности работников; обеспечения сохранности имущества;
            обеспечения пропускного режима.
          </Text>
        </li>
        <li>
          <Text type="p">
            2.2. Обработку персональных данных Общество осуществляет руководствуясь Гражданским кодексом Российской
            Федерации; Налоговым кодексом Российской Федерации; Трудовым кодексом Российской Федерации; Федеральными
            законами от 07.08.2001  №115-ФЗ «О противодействии легализации (отмыванию) доходов, полученных преступным
            путем, и финансированию терроризма», от 06.12.2011 №402-ФЗ «О бухгалтерском учете», от 08.08.2001 №129-ФЗ
            «О государственной регистрации юридических лиц и индивидуальных предпринимателей», от 01.04.1996 №27-ФЗ
            «Об индивидуальном (персонифицированном) учете в системе обязательного пенсионного страхования», от
            16.07.1999 №165-ФЗ «Об основах обязательного социального страхования», от 29.12.2006 №255-ФЗ
            «Об обязательном социальном страховании на случай временной нетрудоспособности и в связи с материнством»,
            от 24.07.1998 №125-ФЗ «Об обязательном социальном страховании от несчастных случаев на производстве и
            профессиональных заболеваний», от 28.03.1998 №53-ФЗ «О воинской обязанности и военной службе», от
            26.02.1997 №31-ФЗ «О мобилизационной подготовке и мобилизации в Российской Федерации», Уставом; согласиями
            субъектов персональных данных на обработку персональных данных.
          </Text>
        </li>
        <li>
          <Text type="p">
            2.3. В связи с реализацией своих прав и обязанностей как юридического лица Обществом обрабатываются ПДн
            следующих категорий субъектов: физические лица, состоящие в трудовых и гражданско-правовых отношениях с
            Обществом, его участники, учредители, уволенные сотрудники; физические лица, состоящие в трудовых и
            гражданско-правовых отношениях с контрагентами Общества, их участники, учредители, в предусмотренных
            законодательством случаях – родственники указанных выше лиц; кандидаты на замещение вакантных должностей;
            уполномоченные на основании доверенности или в силу закона представители вышеперечисленных субъектов;
            посетители сайта Общества, пользователи сервисов/приложений/продуктов под брендом 1С, направляющие запрос
            Обществу, самостоятельно указывающие свои данные в соответствующих формах сервисов/приложений/продуктов,
            в т.ч. с целью установления с Обществом гражданско-правовых отношений, заключения договора.
          </Text>
        </li>
        <li>
          <Text type="p">
            2.4. ПДн получаются и обрабатываются Обществом при наличии согласия субъекта ПДн или на основании
            федеральных законов и иных нормативных правовых актов Российской Федерации без согласия субъекта.
          </Text>
        </li>
        <li>
          <Text type="p">
            2.5. Субъект ПДн соглашается с осуществлением Обществом передачи ПДн ООО «СМС-центр» (123112, г.Москва,
            Пресненская наб., 12, офис А35, ИНН 7724805644, ОГРН 1117746756489) в целях осуществления процедуры
            регистрации (авторизации) на сайте Общества, в продуктах/сервисах Общества посредством получения от
            операторов связи коротких текстовых сообщений (sms-сообщений) на абонентский номер. Общество в
            установленном порядке вправе поручить обработку ПДн также иным третьим лицам при наличии согласия
            субъекта ПДн.
          </Text>
        </li>
        <li>
          <Text type="p">
            2.6. Общество предоставляет обрабатываемые им ПДн государственным и муниципальным органам, органам
            государственных внебюджетных фондов, а также учреждениям, имеющим, в соответствии с федеральным законом,
            право на получение соответствующих ПДн.
          </Text>
        </li>
        <li>
          <Text type="p">
            2.7. При обработке ПДн обеспечиваются их точность, достаточность, а при необходимости – и актуальность
            по отношению к целям обработки. Общество принимает необходимые меры по удалению или уточнению неполных
            или неточных ПДн.
          </Text>
        </li>
        <li>
          <Text type="p">
            2.8. Субъект ПДн соглашается, что ПДн могут обрабатываться до момента достижения Обществом целей обработки,
            указанных в настоящей Политике, за исключением случаев, когда иной срок установлен требованиями применимого
            к Обществу законодательства.
          </Text>
        </li>
      </ul>
      <Text type="h2">3. Принципы обеспечения безопасности персональных данных</Text>
      <ul>
        <li>
          <Text type="p">
            3.1. Основной задачей обеспечения безопасности ПДн при их обработке в Обществе является предотвращение
            несанкционированного доступа к ним третьих лиц, предупреждение преднамеренных программно-технических
            и иных воздействий с целью хищения ПДн, разрушения (уничтожения) или искажения их в процессе обработки.
          </Text>
        </li>
        <li>
          <Text type="p">
            3.2. Для обеспечения безопасности ПДн Общество руководствуется следующими принципами:
          </Text>
          <Text type="p">
            1) законность: защита ПДн основывается на положениях нормативных правовых актов и методических документов
            уполномоченных государственных органов в области обработки и защиты ПДн;
          </Text>
          <Text type="p">
            2)  комплексность: защита ПДн строится с использованием ряда правовых, организационных мер и функциональных
            возможностей имеющихся в Обществе технических средств;
          </Text>
          <Text type="p">
            3)  непрерывность: защита ПДн обеспечивается на всех этапах их сбора, накопления, обработки, вплоть до
            уничтожения ПДн;
          </Text>
          <Text type="p">
            4)  своевременность: меры, обеспечивающие надлежащий уровень безопасности ПДн, принимаются до начала их
            обработки;
          </Text>
          <Text type="p">
            5)  устранение несоответствий и совершенствование мер: Обществом производится своевременное устранение
            выявленных нарушений законодательства об обработке и защите ПДн, модернизация и наращивание мер и средств
            защиты ПДн, в том числе на основании оценки новых угроз безопасности ПДн;
          </Text>
          <Text type="p">
            6)  персональная ответственность: ответственность за обеспечение безопасности ПДн возлагается на конкретных
            Работников в пределах их обязанностей, связанных с обработкой и защитой ПДн;
          </Text>
          <Text type="p">
            7)  минимизация прав доступа: доступ к ПДн предоставляется Работникам только в объеме, необходимом для
            выполнения их должностных обязанностей;
          </Text>
          <Text type="p">
            8)  гибкость: обеспечение выполнения функций защиты ПДн при изменении объема и состава обрабатываемых ПДн;
          </Text>
          <Text type="p">
            9)  наблюдаемость и прозрачность: меры по обеспечению безопасности ПДн должны быть спланированы так, чтобы
            результаты их применения были явно наблюдаемы (прозрачны) и могли быть оценены лицами, осуществляющими
            контроль, а также самими субъектами ПДн, в том числе в порядке получения ими письменных ответов на свои
            обращения;
          </Text>
          <Text type="p">
            10) непрерывность контроля и оценки: устанавливаются процедуры периодических проверок соблюдения
            разработанных мер, результаты проверок фиксируются в журналах.
          </Text>
        </li>
      </ul>
      <Text type="h2">4. Доступ к обрабатываемым персональным данным</Text>
      <ul>
        <li>
          <Text type="p">
            4.1. Доступ к обрабатываемым в Обществе ПДн имеют Работники, уполномоченные приказом Общества, а также
            лица, которым Общество поручило обработку ПДн на основании заключенного договора
          </Text>
        </li>
        <li>
          <Text type="p">
            4.2. Доступ Работников к обрабатываемым ПДн осуществляется в соответствии с их должностными обязанностями
            и требованиями локальных нормативных документов Общества.
          </Text>
        </li>
        <li>
          <Text type="p">
            4.3. Порядок доступа субъекта ПДн к его ПДн, обрабатываемым Обществом, определяется в соответствии с
            законодательством и обеспечивается локальными нормативными документами Общества.
          </Text>
        </li>
        <li>
          <Text type="p">
            4.4. Запросы и обращения субъектов ПДн для получения информации, касающейся обработки их ПДн, следует
            направлять ответственному за организацию обработки персональных данных Общества по адресу: 127434,
            г. Москва, ш. Дмитровское, д. 9, эт/ком 3/63. В аналогичном порядке субъект ПДн может направить письменный
            отзыв согласия на обработку ПДн.
          </Text>
        </li>
      </ul>
      <Text type="h2">5. Реализуемые меры по защите персональных данных</Text>
      <ul>
        <li>
          <Text type="p">
            5.1. Состав правовых, организационных и технических мер определяется, а локальные нормативные документы
            об обработке и защите ПДн утверждаются (издаются) Обществом исходя из требований Закона о ПДн, главы 14
            Трудового кодекса Российской Федерации, а также иных нормативных правовых актов Российской Федерации
            об обработке и защите ПДн.
          </Text>
        </li>
        <li>
          <Text type="p">
            5.2. Обществом осуществляется ознакомление работников Общества, непосредственно осуществляющих обработку
            ПДн, с положениями законодательства о ПДн, в том числе требованиями к защите ПДн, настоящей Политикой
            и иными локальными нормативными документами по вопросам обработки ПДн, при необходимости осуществляется
            обучение указанных работников по вопросам обработки и защиты ПДн.
          </Text>
        </li>
        <li>
          <Text type="p">
            5.3. При обработке ПДн применяются следующие организационные меры:
          </Text>
          <Text type="p">
            1)  назначается Ответственный за организацию обработки ПДн;
          </Text>
          <Text type="p">
            2)  осуществляется ограничение и разграничение доступа Работников;
          </Text>
          <Text type="p">
            3)  осуществляется внутренний контроль и (или) аудит соответствия обработки ПДн Закону о ПДн и принятым
            в соответствии с ним нормативным правовым актам, требованиям к защите ПДн, Политике и другим нормативным
            документам Общества;
          </Text>
          <Text type="p">
            4)  проводятся иные меры, направленные на обеспечение исполнения обязанностей, предусмотренных Законом
            о ПДн, в частности, моделирование угроз и оценка рисков.
          </Text>
        </li>
        <li>
          <Text type="p">
            5.4. При обработке ПДн применяются следующие технические меры:
          </Text>
          <Text type="p">
            1)  устанавливается пропускной режим и физическая охрана помещений, используются запирающие устройства;
          </Text>
          <Text type="p">
            2)  используются средства сигнализации и фиксации событий для обнаружение фактов несанкционированного
            доступа к ПДн и принятия соответствующих мер;
          </Text>
          <Text type="p">
            3)  при обработке ПДн в информационных системах (ИСПДн) обеспечивается применение средств защиты информации
            для обеспечения соответствующего уровня защищенности, мер по восстановлению модифицированных или уничтоженных
            ПДн, мер для регистрации и учета всех действий, совершаемых с ПДн в информационной системе персональных данных.
          </Text>
        </li>
      </ul>
    </ContentLayout>
  );
};

export default PrivacyPolicy;
